import React from 'react';
import { Helmet } from 'react-helmet';

const defaultTitle = 'DPC Nation';
const defaultDescription = '';
const defaultURL = '';
const defaultImage = '/img/banner.png';

const Head = props => {
  let { title, description, url, image } = props;

  title = title || defaultTitle;
  description = description || defaultDescription;
  url = `https://dpcnation.org${url || defaultURL}`;
  image = `https://dpcnation.org${image || defaultImage}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="viewport" property="viewport" content="width=device-width, initial-scale=1" />

      <meta name="title" property="title" content={title} />
      <meta name="description" property="description" content={description} />
      <meta name="image" property="image" content={image} />
      <link rel="canonical" href={url} />

      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" href="/favicon.ico" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <meta name="msapplication-TileColor" property="msapplication-TileColor" content="#da532c" />
      <meta name="theme-color" property="theme-color" content="#ffffff" />

      <meta name="og:url" property="og:url" content={url} />
      <meta name="og:title" property="og:title" content={title} />
      <meta name="og:description" property="og:description" content={description} />
      <meta name="og:image" property="og:image" content={image} />
      <meta name="og:image:width" property="og:image:width" content="1194" />
      <meta name="og:image:height" property="og:image:height" content="691" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@dpcnation" />
      <meta name="twitter:creator" content="@vriad" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <script src="https://cdn.auth0.com/js/auth0/9.5.1/auth0.min.js" />

      <div id="fb-root" />
      <script
        async
        defer
        src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2&appId=1462655830632083&autoLogAppEvents=1"
      />

      <script async src={'https://www.googletagmanager.com/gtag/js?id=UA-134639651-1'} />
      <script>
        {` window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments); }
        gtag('js', new Date());
      
        gtag('config', 'UA-134639651-1');`}
      </script>
    </Helmet>
  );
};

export default Head;
